/** The response arrived but its body could not be parsed, for example JSON longer than the browser can hold in one string. */
export class ResponseParseError extends Error {
    public readonly endpoint: string;

    constructor({ endpoint, cause }: { endpoint: string; cause: unknown }) {
        super(['Could not parse the response of', `    ${endpoint}`, ''].join('\n\n'), { cause });

        this.endpoint = endpoint;
    }
}
